import { render } from "./BackBarTutorialAnimation1.vue?vue&type=template&id=2b538689&scoped=true&ts=true"
import script from "./BackBarTutorialAnimation1.vue?vue&type=script&lang=ts"
export * from "./BackBarTutorialAnimation1.vue?vue&type=script&lang=ts"

import "./BackBarTutorialAnimation1.vue?vue&type=style&index=0&id=2b538689&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b538689"]])

export default __exports__